<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head"><a id="page_5">C<span class="small">ONTENTS</span></a></p><a id="page_5">
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><a href="#/Chapter1#C1">1.</a></td><td><a href="#/Chapter1#C1">Babyland</a></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">Potter’s Field</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">Cochise County Graves and Cemeteries</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">Pima County Graves and Cemeteries</span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">Santa Cruz County Graves and Cemeteries</span></td></tr>
<tr><td colspan="2"><span href="#/Index" title="Link target outside of Sample">Index of Cemetery Locations</span></td></tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?203d7200